const tagUrlAliases: Record<string, string> = {
  '+1/+1 Counters': 'plus-counters',
  '-1/-1 Counters': 'minus-counters',
  'Tap/Untap': 'tap-untap',
}

export const tagNameToUrl = (tagName: string) => {
  if (tagUrlAliases[tagName]) return tagUrlAliases[tagName]

  return tagName.replace(/ /g, '_').toLocaleLowerCase()
}

export const urlToTag = (slug: string, skipEncode = false) => {
  const reversedAliases = Object.fromEntries(Object.entries(tagUrlAliases).map(([k, v]) => [v, k]))

  let alias = slug

  if (reversedAliases[alias]) alias = reversedAliases[alias]

  if (skipEncode) return alias.replace(/_/g, ' ')

  return encodeURIComponent(alias.replace(/_/g, ' '))
}
